<template>
    <div class='ol-main'>
        <van-sticky
            type="primary"
        >
            <van-nav-bar
                v-if="isWechat"
                title="我的订单"
                left-text="返回"
                left-arrow
                @click-left="onGoBack"
            />
            <van-tabs v-model="orderState" @change="onTabChange">
                <van-tab title="全部" name="ALL"/>
                <van-tab title="待支付" name='TO_PAY'/>
                <van-tab title="待发货" name='TO_SEND'/>
                <van-tab title="待收货" name='TO_RECEIVE'/>
                <van-tab title="已完成" name='SUCCESS'/>
                <van-tab title="售后" name='AFTER_SALE'/>
                <van-tab title="已关闭" name='CLOSED'/>
            </van-tabs>
        </van-sticky>
        <van-pull-refresh
            v-model="isRefreshing"
            @refresh="onRefresh"
        >
            <van-list
                v-model='loading'
                :finished="finished"
                finished-text="没有更多了"
                @load="loadMore"
            >
                <!-- 本来应该是多个商品item循环遍历的。但因为卡券商城的特殊性，这里默认只取第一个 -->
                <tic-order-item-card 
                    v-for="(order, index) in list"
                    :key="order.id"
                    :index="index"
                    :order-state="order.orderState"
                    :order-no="order.orderNo"
                    :sku-price="order.itemList[0].skuPrice"
                    :sku-name="order.itemList[0].skuName"
                    :cover-pic="order.itemList[0].skuCoverPic"
                    :item-info-list="order.itemList[0].itemInfoList"
                    :num="order.itemList[0].num"
                    :actual-order-price="order.actualOrderPrice"
                    :raw-order-price="order.rawOrderPrice"
                    @click.native="onOrderClick(order.orderNo)"
                    @action="onOrderAction"
                />
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import {Tabs, Tab, List, Sticky, NavBar, PullRefresh } from "vant";
import OrderItemCard from "@/components/OrderItemCard.vue";
import {navMixins, wechatMixins} from "@/mixins.js";
import request from "@/utils/request.js";
import wechat from "@/utils/wechat.js"

export default {
    name: 'OrderList',
    mixins: [navMixins, wechatMixins],
    components: {
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [List.name]: List,
        [Sticky.name]: Sticky,
        [NavBar.name]: NavBar,
        [OrderItemCard.name]: OrderItemCard,
        [PullRefresh.name]: PullRefresh
    },
    data() {
        return {
            orderState: "ALL",
            pageNum: 0,
            pageSize: 10,
            finished: true,
            loading: false,
            isRefreshing: false,
            list: []
        };
    },
    created() {
    },
    mounted() {
        this.orderState = this.$route.query.orderState;
        this.loadMore();
    },
    methods: {
        async onRefresh() {
            try {
                this.resetData();
                await this.loadMore();
            } finally {
                this.isRefreshing = false;
            }
        },
        resetData() {
            this.pageNum = 0;
            this.list = [];
            this.finished = true;
            this.loading = false;
        },
        onTabChange() {
            this.resetData();
            this.loadMore();
        },
        async loadMore() {
            const body = {
                pageNum: this.pageNum + 1,
                pageSize: this.pageSize
            };
            if (this.orderState === 'AFTER_SALE') {
                body.orderStates=["POST_SALE", "REFUNDED", "NEGATIVE"];
            } else if (this.orderState === 'ALL') {
                body.orderState = undefined;
            } else {
                body.orderState = this.orderState;
            }
            try {
                const {response, data} = await request.post('/customer/order/searchOrder', {
                    data: body
                });

                if (response.ok) {
                    if (data.data) {
                        this.list = [...this.list, ...data.data];
                    }
                    this.pageNum = data.pageNum;
                    this.pageSize = data.pageSize;
                    this.finished = data.pages <= this.pageNum;
                }
            } finally {
                this.loading = false;
            }
        },
        onOrderClick(orderNo) {
            this.$router.push(`/order/${orderNo}`);
        },
        async onOrderAction(type, args) {
            switch(type) {
                case "viewTicket": 
                    this.$router.push(`/ticket/${args.orderNo}`);
                    break;

                case "postSale": 
                    this.$router.push(`/post-sale?orderNo=${args.orderNo}&skuCode=${args.skuCode}&skuName=${args.skuName}`);
                    break;
                case "toPay": {

                    const {data} = await request.post('/customer/payment/createPayOrder', {
                        data: {
                            orderNo: args.orderNo,
                            payType: "WECHAT_JSAPI"
                        }
                    });
                    const paymentParam = JSON.parse(data.paymentParam);
                    // 拉起Wap支付
                    wechat.triggerWapPayment(paymentParam.appId,
                                            paymentParam.timeStamp,
                                            paymentParam.nonceStr,
                                            paymentParam.package,
                                            paymentParam.signType,
                                            paymentParam.paySign, () => {
                                                this.$router.push(`/order/${args.orderNo}`);
                                            });
                    break;
                }
                case "cancelOrder": {
                    const {response} = await request.get(`/customer/order/closeOrder?orderNo=${args.orderNo}`);
                    if (response.ok) {
                        this.$notify({message: "取消成功", type: "success"});
                        this.list[args.index].orderState="CLOSED";
                    }
                    break;
                }
                case "ensure": {
                    const {response} = await request.get(`/customer/order/ensureOrder?orderNo=${args.orderNo}`); 
                    if (response.ok) {
                        this.$notify({message: "确认收货", type: "success"});
                        this.list[args.index].orderState="SUCCESS";
                    }
                    break;
                }
                case "cancelPostSale": { 
                    const {response} = await request.get(`/customer/order/cancelPostSale?orderNo=${args.orderNo}`); 
                    if (response.ok) {
                        this.$notify({message: "取消成功", type: "success"});
                        this.list[args.index].orderState="SUCCESS";
                    }
                    break;
                }
            }
        }
    }
};
</script>

<style lang='less'>
@import "@/style/base.less";
.ol-main {
    .van-list {
        min-height: 100vh;
    }

    .van-tabs__line {
        background-color: @color-theme;
    }
}
</style>